export function getColors() {
	const colors = [
		{ value: null, type: "empty" },
		{ value: "#E47E7E" },
		{ value: "#DEAB6E" },
		{ value: "#73AF67" },
		{ value: "#59C1CB" },
		{ value: "#78A3E8" },
		{ value: "#968BD6" },
		{ value: "#EEA1EE" },
	];
	return colors;
}

export function getStatisticColors() {
	const colors = [
		{ value: "#59C1CB" },
		{ value: "#E47E7E" },
		{ value: "#73AF67" },
		{ value: "#968BD6" },
		{ value: "#78A3E8" },
		{ value: "#EEA1EE" },
		{ value: "#DEAB6E" },
	];
	return colors;
}

export function getColorsValues(palitra) {
	return palitra
		.filter(c => c.type !== "empty" && c.value)
		.map(c => c.value);
}

export function generateColor(index, palitra = 'general') {
	let colors;

	switch (palitra) {
		case 'statistics':
			colors = getColorsValues(getStatisticColors());
			break;

		default:
			colors = getColorsValues(getColors());
			break;
	}

	return colors[index % colors.length];
}